// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"bf35ec56","485":"bf35ec56","644":"62f0fb0d","719":"bf35ec56","839":"bf35ec56"}[chunkId] + ".chunk.css";
};